import {FC} from 'react'

import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

export const CheckCircleOutlineIcon: FC<IconProps> = ({
  color = theme.palette.success.contrastText,
  size,
}) => (
  <>
    <Icon size={size}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.886 7.14272C14.1055 6.79145 13.9987 6.32874 13.6475 6.10924C13.2962 5.88974 12.8335 5.99657 12.614 6.34784L8.91187 12.2725L7.33803 10.2845C7.08092 9.95972 6.60923 9.90488 6.28447 10.162C5.95971 10.4191 5.90486 10.8908 6.16197 11.2155L8.39613 14.0376C8.54749 14.2288 8.78234 14.3345 9.02582 14.3209C9.26929 14.3074 9.49098 14.1763 9.6202 13.9695L13.886 7.14272Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 1C5.02943 1 1 5.02944 1 10C0.999999 14.9706 5.02943 19 10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1ZM2.5 10C2.5 5.85787 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85787 17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10Z"
          fill={color}
        />
      </svg>
    </Icon>
  </>
)
